import React from 'react'
import { Updater, fromJSX, Widget, async } from 'widgets-for-react'
import { renderReadSpeaker, State } from '../../cmsPage.widget'
import { renderModernBlocks } from '../../cmsPage.layout'
import { SharingLayout } from '../../header/pageHeader/sharing.layout'
import { ReadSpeaker } from '../../../readspeaker/readspeaker.widget'
import { StoryPageDatasheetState } from './storyPage.state'

export const storyPageWidget = (state: State): Widget<Updater<State>> => {
  const datasheet = state.storyPageState.datasheet
  return fromJSX((setState) => {
    return (
      <div className="page__inner ls-container--l">
        {async(datasheet).run((datasheetUpdater) => {
          setState((s) => ({
            ...s,
            storyPageState: { ...s.storyPageState, datasheet: datasheetUpdater(s.storyPageState.datasheet) },
          }))
        })}
        <div id="blocks" className="blocks">
          <SharingLayout.Wrap>
            {renderReadSpeaker(state) == true && (
              <ReadSpeaker keyId="a1" encodedUrl={encodeURI(window.location.href)} readElementId={'a11y-main'} />
            )}
            <SharingLayout.Button />
            <SharingLayout.Popup />
          </SharingLayout.Wrap>
          {renderModernBlocks(state, setState)}
        </div>
        {datasheet.kind === 'loaded' && <DataSheet datasheet={datasheet.value} />}
      </div>
    )
  })
}

const DataSheet = (props: { datasheet: StoryPageDatasheetState }) => {
  React.useEffect(() => {
    const datasheet = document.getElementById('datasheet--box')
    const datasheetContainer = document.getElementById('datasheet')
    if (datasheet === null || datasheetContainer === null) return

    const datasheetInitialOffset = datasheetContainer?.offsetTop || 0
    const datasheetInitialOffsetLeft = datasheetContainer?.offsetLeft || 0

    const datasheetLastOffset = datasheetInitialOffset + datasheetContainer.offsetHeight

    window.addEventListener('scroll', () => {
      if (window.scrollY >= datasheetInitialOffset && window.scrollY <= datasheetLastOffset - 380) {
        datasheet?.classList.add('container--sticky')
        datasheet.style.left = `${datasheetInitialOffsetLeft}px`
      } else {
        datasheet?.classList.remove('container--sticky')
        datasheet.style.left = '0px'
      }

      if (window.scrollY > datasheetLastOffset - 380) {
        datasheet?.classList.add('container--sticky-bottom')
      } else {
        datasheet?.classList.remove('container--sticky-bottom')
      }
    })
  }, [])

  const datasheet = props.datasheet

  return datasheet.name || datasheet.age || datasheet.disease ? (
    <div id="datasheet" className="datasheet">
      <div id="datasheet--box" className="datasheet__inner">
        {datasheet.name && (
          <div className="datasheet__item">
            <label className="datasheet__item--label">Naam</label>
            <p className="datasheet__item--value">{datasheet.name}</p>
          </div>
        )}
        {datasheet.age && (
          <div className="datasheet__item">
            <label className="datasheet__item--label">Leeftijd</label>
            <p className="datasheet__item--value">{datasheet.age}</p>
          </div>
        )}
        {datasheet.disease && (
          <div className="datasheet__item">
            <label className="datasheet__item--label">Reumatische aandoening</label>
            <p className="datasheet__item--value">{datasheet.disease}</p>
          </div>
        )}
      </div>
    </div>
  ) : (
    <></>
  )
}
